import { type App, createApp, h } from 'vue'

import MarkdownCollapse from '@fondof-ui/components/markdown/MarkdownCollapse.vue'
import type { marked } from 'marked'

export const markdownCollapse: marked.TokenizerAndRendererExtension = {
  name: 'collapse',
  level: 'inline',
  start: (src) => src.match(/<collapse>/)?.index,
  tokenizer(src) {
    const rule = /^<collapse>(.*?)<\/collapse>/s
    const match = rule.exec(src)
    if (match) {
      const token = {
        type: 'collapse',
        raw: match[0],
        text: match[1].trim(),
        tokens: [],
      }
      this.lexer.inline(token.text, token.tokens)
      return token
    }
  },
  renderer(token) {
    const inner = this.parser.parseInline(token.tokens || [])

    return `<span data-markdown-collapse>${inner}</span>`
  },
}

const markdownCollapseApps = new WeakMap<HTMLElement, App<Element>>()

export const enhanceMarkdownCollapse = (root: HTMLElement) => {
  root
    .querySelectorAll<HTMLElement>('[data-markdown-collapse]')
    .forEach((container) => {
      const content = container.innerHTML

      if (!content) {
        return
      }

      const app = createApp(h(MarkdownCollapse, { content }))
      markdownCollapseApps.set(container, app)
      app.mount(container)
    })
}

export const unmountMarkdownCollapse = (root: HTMLElement) => {
  root
    .querySelectorAll<HTMLElement>('[data-markdown-collapse]')
    .forEach((container) => {
      const app = markdownCollapseApps.get(container)

      if (!app) {
        return
      }

      app.unmount()
      markdownCollapseApps.delete(container)
    })
}
